import { Image } from '@/shared/ui'

import { PlaceholderThumbnail } from './placeholder-thumbnail'

export type DashboardThumbnail = {
  moreCount: number
  url: string
  showMoreCount: boolean
}

export type Props = {
  thumbnails: DashboardThumbnail[]
  title: string
}

export const ThumbnailGroup = ({ thumbnails, title }: Props) => {
  return (
    <div className="flex -space-x-2.5 *:rounded-full *:ring-2 *:ring-white *:transition-all *:duration-300 group-hover:*:text-gray-50 group-hover:*:ring-gray-50">
      {thumbnails.map((thumbnail, idx) => {
        if (thumbnail.showMoreCount) {
          return (
            <div
              className="typo-caption2 relative flex h-8 w-8 items-center justify-center bg-gray-900 font-bold text-white"
              key={idx}
            >
              +{thumbnail.moreCount}
            </div>
          )
        }

        return (
          <Image
            src={thumbnail.url}
            alt={`${title} ${idx + 1}번째 방`}
            width={32}
            height={32}
            key={idx}
            fallback={<PlaceholderThumbnail />}
          />
        )
      })}
    </div>
  )
}
